import React from 'react'
import {Card, CardContent, Typography} from "@material-ui/core";

import './InfoBox.css';


function InfoBox({title, cases, active, total, isRed, isOrange, ...props}) {
    return (
        <div>
            <Card
            onClick = {props.onClick}
            className={`infoBox ${active && 'infoBox--selected'} ${ active && isRed && 'infoBox--red'} ${ active && isOrange && ' infoBox--orange'}` }>
                <CardContent className=''>
                    <Typography className='InfoBox-title' color= 'textSecondary'>
                          {title}
                    </Typography>

                    <h2 className={`InfoBox-cases ${!isRed && !isOrange && 'infoBox__recovered--green'} ${!isRed && 'infoBox__deaths--orange'}`}>{cases}</h2>

                    <Typography className='InfoBox-total' color= 'textSecondary'>
                        {total} Total  
                    </Typography>
                </CardContent>
            </Card>
        </div>
    )
}

export default InfoBox
